import { createAsyncThunk } from "@reduxjs/toolkit";
import { aboutImagesService } from "service/aboutImagesService";
import { NOTIFY } from "constants/notifyType";
import Notify from "helpers/Notify";

export const getAllAboutImages = createAsyncThunk(
  "aboutImages/getAllAboutImages",
  async (pageOptions = {}) => {
    try {
      const response = await aboutImagesService.getAllAboutImages(pageOptions);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getAboutImageById = createAsyncThunk(
  "aboutImages/getAboutImageById",
  async (id) => {
    try {
      const response = await aboutImagesService.getAboutImageById(id);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const createAboutImage = createAsyncThunk(
  "aboutImages/createAboutImage",
  async (imageData, { rejectWithValue }) => {
    try {
      const response = await aboutImagesService.createAboutImage(imageData);
      Notify(NOTIFY.type.success, NOTIFY.message.add);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error);
    }
  }
);

export const updateAboutImage = createAsyncThunk(
  "aboutImages/updateAboutImage",
  async ({ id, imageData }, { rejectWithValue }) => {
    try {
      const response = await aboutImagesService.updateAboutImage(id, imageData);
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error);
    }
  }
);

export const deleteAboutImage = createAsyncThunk(
  "aboutImages/deleteAboutImage",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      await aboutImagesService.deleteAboutImage(id);
      Notify(NOTIFY.type.success, NOTIFY.message.delete);
      dispatch(getAllAboutImages());
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error);
    }
  }
);

export const reorderAboutImages = createAsyncThunk(
  "aboutImages/reorderAboutImages",
  async (aboutImageIds, { rejectWithValue }) => {
    try {
      const response = await aboutImagesService.reorderAboutImages(
        aboutImageIds
      );
      Notify(NOTIFY.type.success, NOTIFY.message.reorder);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error);
    }
  }
);
